export const BUTTON_LIGHTGRAY = '#eee'
export const BUTTON_LIGHTGRAY_HOVER = '#eaeaea'
